import { AUTH_URL_CUSTOMER_SUBSCRIPTION_KEY } from "./envVariables";

export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const localPartRegex = /^[a-zA-Z0-9._%+-]+$/;
  const parts = email.split('@');
  if (parts.length !== 2) {
    return false;
  }
  const [localPart, domainPart] = parts;
  if (!emailRegex.test(email)) {
    return false;
  }
  if (!localPartRegex.test(localPart)) {
    return false;
  }
  const domainParts = domainPart.split('.');
  if (domainParts.length < 2 || domainParts.some((part) => !/^[a-zA-Z0-9-]+$/.test(part))) {
    return false;
  }
  return true;
};

export const headers = {
  'Content-Type': 'application/json',
  'Ocp-Apim-Subscription-Key': AUTH_URL_CUSTOMER_SUBSCRIPTION_KEY || '',
};
export const BUSINESS_UNIT_POSTAL_CODE = 'business-unit-postal-code';
